var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarehouseOrangeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_38046_74608)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9 13.6966V4.60367C13.9 4.53511 13.8634 4.46791 13.7976 4.42974L8.11009 1.12946C8.0424 1.09018 7.9576 1.09018 7.88991 1.12946L2.20241 4.42974C2.13663 4.46791 2.1 4.53511 2.1 4.60367V13.6966C2.1 13.8017 2.1879 13.9 2.3125 13.9H13.6875C13.8121 13.9 13.9 13.8017 13.9 13.6966ZM1.65033 3.47832C1.24758 3.71202 1 4.14044 1 4.60367V13.6966C1 14.4165 1.58763 15 2.3125 15H13.6875C14.4124 15 15 14.4165 15 13.6966V4.60367C15 4.14044 14.7524 3.71202 14.3497 3.47832L8.66217 0.178035C8.25308 -0.0593452 7.74692 -0.059345 7.33783 0.178035L1.65033 3.47832Z",
    fill: "#EE741F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 6.5C6.5 6.22386 6.72386 6 7 6H9C9.27614 6 9.5 6.22386 9.5 6.5V8.5C9.5 8.77614 9.27614 9 9 9H7C6.72386 9 6.5 8.77614 6.5 8.5V6.5Z",
    fill: "#EE741F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 10.5C4 10.2239 4.22386 10 4.5 10H6.5C6.77614 10 7 10.2239 7 10.5V12.5C7 12.7761 6.77614 13 6.5 13H4.5C4.22386 13 4 12.7761 4 12.5V10.5Z",
    fill: "#EE741F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 10.5C9 10.2239 9.22386 10 9.5 10H11.5C11.7761 10 12 10.2239 12 10.5V12.5C12 12.7761 11.7761 13 11.5 13H9.5C9.22386 13 9 12.7761 9 12.5V10.5Z",
    fill: "#EE741F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38046_74608"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouseOrangeIcon);
export default __webpack_public_path__ + "static/media/warehouse-orange-icon.d332f5ef2304f35b36fb716da9e118f2.svg";
export { ForwardRef as ReactComponent };